<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 35.71 34">
    <g id="Calque_2" data-name="Calque 2">
      <g id="ƒŒƒCƒ_1" data-name="ƒŒƒCƒ„[ 1">
        <path
          class="cls-1"
          d="M30.65,34H11.47a1.31,1.31,0,0,1-1.31-1.31V20.57a.72.72,0,1,1,1.43,0v12H30.53v-12a.72.72,0,1,1,1.43,0V32.69A1.31,1.31,0,0,1,30.65,34Z"
        />
        <path
          class="cls-1"
          d="M31.25,6.13h-4.8a.72.72,0,0,0-.72.72v3.94a.72.72,0,0,0,1.43,0V7.56h3.37v8.3a.72.72,0,0,0,1.43,0v-9A.71.71,0,0,0,31.25,6.13Z"
        />
        <path
          class="cls-1"
          d="M35,23a.7.7,0,0,1-.52-.22l-13.23-14a.27.27,0,0,0-.19-.08.29.29,0,0,0-.2.08l-13.22,14a.71.71,0,0,1-1-1l13.23-14a1.69,1.69,0,0,1,2.46,0l13.22,14a.71.71,0,0,1,0,1A.72.72,0,0,1,35,23Z"
        />
        <path class="cls-2" d="M24.33,33.29H18v-6a3.16,3.16,0,0,1,3.16-3.16h0a3.16,3.16,0,0,1,3.15,3.16Z" />
        <path
          class="cls-1"
          d="M24.33,34H18a.71.71,0,0,1-.72-.71v-6a3.88,3.88,0,0,1,7.75,0v6A.71.71,0,0,1,24.33,34Zm-5.6-1.43h4.89V27.28a2.45,2.45,0,0,0-4.89,0Z"
        />
        <path
          class="cls-1"
          d="M4.43,32.57H3.29V22.46H4.43a.72.72,0,0,0,0-1.43H.71a.72.72,0,0,0,0,1.43H1.86V32.57H.71A.72.72,0,0,0,.71,34H4.43a.72.72,0,0,0,0-1.43Z"
        />
        <path
          class="cls-1"
          d="M31.25,0a.71.71,0,0,0-.72.71V1.86H11V.71a.72.72,0,0,0-1.43,0V4.43a.72.72,0,0,0,1.43,0V3.29H30.53V4.43a.72.72,0,0,0,1.43,0V.71A.71.71,0,0,0,31.25,0Z"
        />
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'IconHome',
};
</script>

<style scoped>
.cls-1 {
  fill: #162b46;
}

.cls-2 {
  fill: #f9802f;
}
</style>
